import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-bur',
  templateUrl: './bur.component.html',
  styleUrls: ['./bur.component.scss'],
})
export class BurComponent implements OnInit {
  @Input() formData: any;

  burDescriptionVisible = false;

  constructor() { }

  ngOnInit() {}

  toggleBurDescriptionVisibility() {
    this.burDescriptionVisible = !this.burDescriptionVisible;
  }

}
